import { SnackbarProvider } from "notistack";
import "../src/assets/css/style.css";
import ApppRoutes from "./routes";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./generalComponnets/themes/MuiTheme";
import { IdsProvider } from "./hook/AdminContext";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "react-image-gallery/styles/css/image-gallery.css";
import GoogleAnalytics from "./GoogleAnalytic";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

// Initialize Stripe
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'your-stripe-publishable-key-here');

function App() {
  if (window.location.hostname !== "localhost") {
    console.log = () => {};
  }

  return (
    <>
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          maxSnack={3}
        >
          <Elements stripe={stripePromise}>
            <IdsProvider>
              <GoogleAnalytics />
              <ApppRoutes />
            </IdsProvider>
          </Elements>
        </SnackbarProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
